<template>
<div class="flex-container">
  <div class="img-container">
    <img class="rotate"
      src="@/assets/images/gear.png"
    />
  </div>
</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.flex-container {
  position: absolute;
  width: 100%;
  height: 100%;
}
.img-container {
  position: relative;
  top: 30%;
  width: 150px;
  margin: auto;
  height: 150px;
  object-fit: contain;
  img {
    width: 100%;
    height: 100%;
  }
}
.rotate {
  animation: rotation 1.5s infinite ease-in-out;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
